<template>
  <div class="virtual-phone-tabbar-wrap" v-if="show">
    <div class="virtual-phone-tabbar">
      <div
        class="virtual-phone-tabbar_item"
        v-for="item in list"
        :key="item.route"
        @click="change(item.route)"
      >
        <img class="img-btn" draggable="false" :src="assets(item.icon, active === item.route)" />
      </div>
    </div>
  </div>
</template>

<script>
import { assets } from '../../utils';

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    assets(icon, status) {
      const pre = status ? 'active-' : '';
      return assets({ icon: `${pre}${icon}`, dir: '/tabbar' });
    },
    change(name) {
      this.$emit('update:active', name);
      this.$emit('switch', name);
    }
  }
};
</script>

<style lang="scss">
.virtual-phone-tabbar-wrap {
  min-height: 10.5%;
}
.virtual-phone-tabbar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10.5%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: linear-gradient(269deg, #241d1b 0%, #000000 49%, #241d1b 100%);
  user-select: none;
  .virtual-phone-tabbar_item {
    cursor: pointer;
    height: 75%;
    padding: 0 12px;
    .img-btn {
      height: 100%;
    }
  }
}
</style>
